import React from "react";
import { Trophy } from "lucide-react";

/**
 * Main tab screens only. z-20 sits below the More menu overlay (40) and player stats modal (200).
 * @param {{ onOpen: () => void, liftForBanner?: boolean, scrollVisible?: boolean }} props
 */
export function PastWinnersFab({
    onOpen,
    liftForBanner = false,
    scrollVisible = true,
}) {
    const bottomClass = liftForBanner
        ? "bottom-32 sm:bottom-36"
        : "bottom-6 sm:bottom-8";
    return (
        <button
            type="button"
            onClick={onOpen}
            className={`fixed right-4 z-20 flex h-14 w-14 items-center justify-center rounded-full border border-masters-gold/40 bg-masters-moss text-masters-gold shadow-lg shadow-black/30 transition-[transform,opacity] duration-300 ease-out will-change-transform hover:bg-masters-pine hover:brightness-110 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-masters-gold sm:right-6 ${bottomClass} ${
                scrollVisible
                    ? "translate-y-0 opacity-100"
                    : "pointer-events-none translate-y-[calc(100%+28px)] opacity-0"
            }`}
            aria-label="Past winners"
            tabIndex={scrollVisible ? 0 : -1}
        >
            <Trophy className="h-7 w-7" strokeWidth={1.75} aria-hidden />
        </button>
    );
}
